import React, { ButtonHTMLAttributes } from "react";

export function SubButton(props: ButtonProps & ButtonHTMLAttributes<HTMLButtonElement>) {

    const { children, width, backgroundColor, ...rest } = props;
    const styles = { width: width ?? "64px", backgroundColor: backgroundColor ?? "transparent" };
    return (
        <button style={styles} { ...rest} className={"sub_button"}>
            <span>
                { children }
            </span>
        </button>
    );
}

type ButtonProps = {
    width?: string
    backgroundColor?: string
}
